import { useMutation } from '@tanstack/react-query';
import { useDialogs, useNotifications } from '@toolpad/core';
import { useNavigate } from 'react-router';
import {
    Card,
    CardContent,
    CardHeader,
    Stack,
    Typography,
} from '@mui/material';
import Button from '@mui/material/Button';

import Api from '@barboxx/api';
import { BusinessDefaultProduct } from '@barboxx/models';

interface Props {
    businessDefaultProduct: BusinessDefaultProduct.DetailsResponse;
}

export const BusinessDefaultProductDeleteCard = ({
    businessDefaultProduct,
}: Props) => {
    const notifications = useNotifications();
    const navigate = useNavigate();
    const dialog = useDialogs();

    const mutateDeleteBusinessDefaultProduct = useMutation({
        mutationKey: [
            'deleteBusinessDefaultProduct',
            businessDefaultProduct.id,
        ],
        mutationFn: () =>
            Api.BusinessSpecific.DefaultProduct.deleteDefaultProduct(
                businessDefaultProduct
            ),
    });

    const onDelete = async () => {
        const deleteConfirmed = await dialog.confirm(
            'Are you sure you want to Delete this default product!',
            {
                severity: 'error',
                okText: 'Delete',
                title: 'Delete Default Product',
            }
        );

        if (!deleteConfirmed) {
            return;
        }

        mutateDeleteBusinessDefaultProduct
            .mutateAsync()
            .then(({ data }) => {
                notifications.show('Deleted default product!', {
                    severity: 'success',
                });
                navigate(-1);
            })
            .catch(e => {
                notifications.show('Error Deleting default product!', {
                    severity: 'error',
                });
            });
    };

    return (
        <Card>
            <CardHeader title="Delete BusinessDefaultProduct" />
            <CardContent>
                <Stack gap={2} direction="row">
                    <Typography flex={1}>
                        Are you sure you want to Delete this default product?
                    </Typography>

                    <Button onClick={onDelete} color="error" variant="outlined">
                        Delete
                    </Button>
                </Stack>
            </CardContent>
        </Card>
    );
};
